import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type WorkspaceNotificationsStatusFragment = { __typename?: 'Workspace', id: string, name: string, projectNotificationsEnabled?: boolean | null };

export const WorkspaceNotificationsStatus = /*#__PURE__*/ gql`
    fragment WorkspaceNotificationsStatus on Workspace {
  id
  name
  projectNotificationsEnabled
}
    ` as unknown as DocumentNode<WorkspaceNotificationsStatusFragment, unknown>;

        

        
export const useWorkspaceNotificationsStatusFragment = (
  input: string | Omit<UseFragmentOptions<WorkspaceNotificationsStatusFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<WorkspaceNotificationsStatusFragment>({
    fragment: WorkspaceNotificationsStatus,
    fragmentName: 'WorkspaceNotificationsStatus',
    ...options,
  });
};
  
        